module.exports = __webpack_public_path__ + "img/PostAdd.74dc332b.png";